import React from 'react'
import Register from "../auth/Register";
import Login from "../auth/Login";
import Profile from "../user/Profile";
import UpdateProfile from "../user/UpdateProfile";
import ProtectedRoute from "../auth/ProtectedRoute";
import UploadAvatar from "../user/UploadAvatar";
import UpdatePassword from "../user/UpdatePassword";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/ResetPassword";
import MyBookings from "../displayBookings/MyBookings";
import BookingDetails from "../displayBookings/BookingDetails";
import  Home  from "../Home";
import {Route, Navigate} from "react-router-dom";
import VerifyEmail from "../auth/VerifyEmail";
import CreateLocalBooking from '../booking/local/CreateLocalBooking';
import CalculateRideCost from '../booking/CalculateRideCost';
import ConfirmRide from '../booking/ConfirmRide';
import LabourDetail from '../booking/LabourDetail';
import GoodsInfo from '../booking/GoodsInfo';
import CreateImportBooking from '../booking/import/CreateImportBooking';
import CreateExportBooking from '../booking/export/CreateExportBooking';
import Terms from '../layout/Terms';
import UpdateUser from '../admin/UpdateUser';
import { useSelector } from 'react-redux';
import  DriverHome  from "../driver/DriverHome";
import PhoneVerify from '../auth/PhoneVerify';
import PotentialBookings from '../driver/local/PotentialBookingsLocal';
import Canceled from '../layout/Canceled';
import  UnderConstruction  from "../layout/UnderConstruction"; 
import ContactUs from '../bs/ContactUs';
import PrivacyPolicy from '../layout/PrivacyPolicy';

const UserRoutes = () => {

    const { user } = useSelector((state) => state.auth) 

  return (
    <>
    
    {user?.role === 'driver' && (
       <Route 
       path="/" 
       element={
       <ProtectedRoute driver={true}>
        <PotentialBookings />
        </ProtectedRoute>
        }
        />  
    )}

       <Route path="/home" element={<Home />}/>
<Route path="/" element={<Navigate to="/ride" replace />}/>  
      

       <Route path="/login" element={<Login />}/>  
       <Route path="/register" element={<Register />}/>  

       <Route path="/password/forgot" element={<ForgotPassword />}/>  
       <Route path="/password/reset/:token" element={<ResetPassword />}/>  

       <Route path="/verify-email" element={<VerifyEmail />}/>

       <Route path="/verify-phone" element={<PhoneVerify />}/>  

       <Route path="/Terms-And-Agreement" element={<Terms />}/>  

       <Route path="/privacy-policy" element={<PrivacyPolicy />}/>  

       <Route path="/Canceled" element={<Canceled />}/>  

       <Route path="/under-construnction" element={<UnderConstruction />}/>

       <Route path="/contact-us" element={<ContactUs />}/>

       <Route 
       path="/me/profile" 
       element={
        <ProtectedRoute>
          <Profile />
          </ProtectedRoute>
        }
        />  
       <Route 
       path="/me/update_profile" 
       element={
          <ProtectedRoute>
            <UpdateProfile />
          </ProtectedRoute>
        }/>  

      <Route 
       path="/me/upload_avatar" 
       element={
          <ProtectedRoute>
            <UploadAvatar />
          </ProtectedRoute>
        }/>  

       <Route 
       path="/me/update_password" 
       element={
          <ProtectedRoute>
            <UpdatePassword />
          </ProtectedRoute>
        }/>  

     <Route 
     path="/create-booking/local" 
     element={
      <ProtectedRoute>
     <CreateLocalBooking />
     </ProtectedRoute>
     }/>  

     <Route 
     path="/calculate-price" 
     element={
      <ProtectedRoute>
     <CalculateRideCost />
     </ProtectedRoute>
     }/>  

     <Route 
     path="/payment_method" 
     element={
      <ProtectedRoute>
     <ConfirmRide />
     </ProtectedRoute>
     }/> 

     <Route 
     path="/me/bookings" 
     element={
      <ProtectedRoute>
     <MyBookings />
     </ProtectedRoute>
     }/> 

    <Route 
     path="/me/booking/:id" 
     element={
      <ProtectedRoute>
     <BookingDetails />
     </ProtectedRoute>
     }/>  

    <Route 
     path="/labour-detail" 
     element={
      <ProtectedRoute>
     <LabourDetail />
     </ProtectedRoute>
     }/>  

    <Route 
     path="/goods-info" 
     element={
      <ProtectedRoute>
     <GoodsInfo />
     </ProtectedRoute>
     }/> 

    <Route 
     path="/create-booking/import" 
     element={
      <ProtectedRoute>
     <CreateImportBooking />
     </ProtectedRoute>
     }/>  

   <Route 
     path="/create-booking/export" 
     element={
      <ProtectedRoute>
     <CreateExportBooking />
     </ProtectedRoute>
     }/> 
    </>
  )
}

export default UserRoutes
